module.exports = "<div class=\"tabs\">\n  <div class=\"tabs__nav\">\n    {{> nav}}\n  </div>\n  <div class=\"tabs__content\">\n    {{> content}}\n  </div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader?interpolate!./src/components/guideline/templates/tabs.html
// module id = 60
// module chunks = 0